import React from 'react';
import { Link } from 'react-router-dom';
import useGetSuggestProducts from '../../../../hooks/products/useGetProductSuggestProducts';

const SuggestedProducts = ({ productId }) => {
  const { suggested, loading, error } = useGetSuggestProducts(productId);

  if (loading) {
    return (
      <div className="text-center py-12 text-gray-400 animate-pulse select-none">
        Loading suggested products...
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12 text-red-500 font-semibold select-none">
        Error loading suggestions: {error.message}
      </div>
    );
  }

  if (suggested.length === 0) {
    return (
      <p className="text-center py-12 text-gray-500 select-none">
        No suggested products available.
      </p>
    );
  }

  return (
    <section className="mt-20 max-w-7xl mx-auto">
      <h2 className="text-3xl font-extrabold mb-8 text-gray-900 tracking-tight">
        You May Also Like
      </h2>

      <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {suggested.map(({ id, name, price, imageUrl, description }) => (
          <Link
            to={`/products/${id}`}
            key={id}
            className="group bg-white rounded-3xl shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col overflow-hidden border border-gray-200 focus:outline-none focus:ring-4 focus:ring-purple-300"
            aria-label={`View details for ${name}`}
            style={{ minHeight: '420px' }}
          >
            <div className="aspect-[4/3] overflow-hidden rounded-t-3xl bg-gray-100 flex-shrink-0">
              <img
                src={imageUrl || 'https://via.placeholder.com/400x300?text=No+Image'}
                alt={name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                loading="lazy"
                width={400}
                height={300}
              />
            </div>
            <div className="p-5 flex flex-col flex-grow">
              <h3 className="text-lg font-semibold text-gray-900 line-clamp-2 mb-1">{name}</h3>
              <p className="text-gray-600 text-sm line-clamp-3 mb-3">{description}</p>
              <p className="mt-auto text-purple-600 font-bold text-xl">${price.toFixed(2)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default SuggestedProducts;
